/*
 * DẢI SẢN PHẨM CHẠY NGANG LIÊN TỤC — eGURU 02/10/2026 (B2 họp 01/10; anh Thắng 00:15 "đổi sang liên tục").
 * MỘT cơ chế cho mọi dải sản phẩm: Swiper (sections/custom-featured-collection — trang chủ, landing) và
 * Owl (sections/custom-product-recommendations — "Bạn cũng có thể thích" ở mọi trang sản phẩm).
 * Hai thư viện chỉ có tự chạy kiểu NHẢY từng thẻ, nên tự lái: mỗi bước gọi "thẻ kế tiếp" với thời gian = TOC và
 * chuyển động tuyến tính, bước sau nối ngay khi bước trước xong → dải trôi đều không ngắt.
 * Rê chuột / tab bàn phím vào dải → ĐỨNG NGAY tại chỗ (đóng băng transform đang chạy) để khách bấm được thẻ;
 * rời ra → đi nốt quãng còn lại đúng tốc độ rồi chạy tiếp. Khách bật "giảm chuyển động" → không tự chạy.
 * Thay cho autoplay 29/09 (1,2 s/thẻ kiểu nhảy).
 *   Swiper: egDaiLienTuc.swiper(swiper, phanTuGoc, khoangCach)
 *   Owl:    egDaiLienTuc.owl($carousel, khoangCach)
 * Nạp defer; nơi gọi chưa thấy egDaiLienTuc thì xếp vào window.__egDaiCho, tệp này chạy hộ khi nạp xong.
 */
(function () {
  'use strict';
  if (window.egDaiLienTuc) return;
  var TOC = 7000; // ms cho mỗi thẻ trôi qua — 02/10 00:25 anh Thắng: "nhanh quá, xoay từ từ" (trước 3000)
  var giam = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var st = document.createElement('style');
  st.textContent = '.eg-dai-lien-tuc .swiper-wrapper{transition-timing-function:linear!important}';
  document.head.appendChild(st);

  function soX(t) {
    if (!t || t === 'none') return 0;
    try { return new DOMMatrixReadOnly(t).m41; } catch (e) {
      var m = /translate3d\((-?[\d.]+)px/.exec(t) || /matrix\([^,]+,[^,]+,[^,]+,[^,]+,\s*(-?[\d.]+)/.exec(t);
      return m ? parseFloat(m[1]) : 0;
    }
  }

  function gan(goc, toi, lop, rong) {
    if (giam || !goc || goc.__egDai) return;
    goc.__egDai = true;
    goc.classList.add('eg-dai-lien-tuc');
    var hen = null, dung = false, bang = null;

    function buoc() {
      hen = null;
      if (dung) return;
      goc.__egBuoc = (goc.__egBuoc || 0) + 1;
      if (!document.hidden) toi(TOC);
      hen = setTimeout(buoc, TOC);
    }
    function dongBang() {
      if (dung) return;
      dung = true; goc.__egDung = true;
      goc.__egBuoc = (goc.__egBuoc || 0) + 1; // lệnh "chờ lượt trước xong" cũ (Swiper) thôi hiệu lực
      clearTimeout(hen); hen = null;
      var el = lop();
      if (!el) return;
      var dich = el.style.transform;
      var nay = getComputedStyle(el).transform;
      var x = soX(nay);
      el.style.transition = 'none';
      el.style.transform = 'translate3d(' + x + 'px, 0px, 0px)';
      bang = { el: el, dich: dich, dat: el.style.transform, con: Math.abs(soX(dich) - x) };
    }
    function chayLai() {
      if (!dung) return;
      dung = false; goc.__egDung = false;
      var b = bang; bang = null;
      var cho = 200;
      // Thư viện chưa động vào (khách không bấm mũi tên / kéo trong lúc dừng) thì đi nốt quãng còn lại
      if (b && b.el.style.transform === b.dat && b.dich) {
        var w = rong() || 1;
        cho = Math.max(50, Math.min(TOC, Math.round(TOC * b.con / w)));
        b.el.style.transition = 'transform ' + cho + 'ms linear';
        b.el.style.transform = b.dich;
        setTimeout(function () { if (b.el.style.transform === b.dich) b.el.style.transition = ''; }, cho + 30);
      }
      clearTimeout(hen);
      hen = setTimeout(buoc, cho);
    }

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      goc.addEventListener('mouseenter', dongBang);
      goc.addEventListener('mouseleave', chayLai);
    }
    goc.addEventListener('focusin', dongBang);
    goc.addEventListener('focusout', function (e) { if (!goc.contains(e.relatedTarget)) chayLai(); });
    hen = setTimeout(buoc, 800);
  }

  window.egDaiLienTuc = {
    swiper: function (sw, goc, khoang) {
      if (!sw || !sw.wrapperEl) return;
      if (sw.autoplay && sw.autoplay.running) sw.autoplay.stop();
      // Swiper chế độ loop BỎ QUA slideNext khi lượt trước chưa xong (loopPreventsSliding) — hẹn giờ tới sớm vài ms
      // là đứng một nhịp (đo ĐT 02/10: khựng ~2,5 s). Đang trượt thì chờ transitionEnd rồi mới gọi.
      var g = goc || sw.el;
      gan(g, function (t) {
        if (!sw.animating) return sw.slideNext(t);
        var so = g.__egBuoc;
        sw.once('transitionEnd', function () { if (!g.__egDung && g.__egBuoc === so) sw.slideNext(t); });
      }, function () { return sw.wrapperEl; },
        function () { return (sw.slidesSizesGrid && sw.slidesSizesGrid[0] || 0) + (khoang || 0); });
    },
    owl: function ($el, khoang) {
      if (!$el || !$el.length) return;
      $el.each(function () {
        var $c = window.jQuery(this);
        $c.trigger('stop.owl.autoplay');
        gan(this, function (t) { $c.trigger('next.owl.carousel', [t]); },
          function () { return $c.find('.owl-stage')[0]; },
          function () { var i = $c.find('.owl-item')[0]; return (i ? i.getBoundingClientRect().width : 0) + (khoang || 0); });
      });
    }
  };
  (window.__egDaiCho || []).splice(0).forEach(function (f) { try { f(); } catch (e) {} });
})();
